__turbopack_context__.v({
  "contacts": "P4bQCG_contacts",
  "jobReferEmail": "P4bQCG_jobReferEmail",
  "jobReferEmailLabel": "P4bQCG_jobReferEmailLabel",
  "jobReferEmailValue": "P4bQCG_jobReferEmailValue",
});
